import {Box, Stack, Typography, Paper} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import BillingService from "../../services/BillingService";
import Team from "./Team/Team";
import Appeals from "./Appeals/Appeals";
import AnaliticsBillings from "../../sections/AnaliticsBillings/AnaliticsBillings"
import Networks from "./Networks/Networks";

const Provider = ({provider}) => {
    const [loading, setLoading] = useState(false);
    const [billings, setBillings] = useState([]);

    const [currentYear, setCurrentYear] = useState(dayjs().startOf('month'))
    const [timeStart, setTimeStart] = useState(dayjs().startOf('month').unix());
    const [timeEnd, setTimeEnd] = useState(dayjs().endOf('day').unix());

    const [value, setValue] = useState("team");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        setValue("team")
        handleUpdateBillings()
    }, [provider]);  

    const handleUpdateBillings = () => {
        setLoading(false)         
        const fetcher = async () => {
            try {
                const billings = await BillingService.getBillings(provider.id);
                setBillings(billings.data.billings)
                setLoading(true)
            } catch (e) {
                console.log(e);
                setLoading(true)
            }
        };
        fetcher()
    }

    const changeCurrentYear = (value) => {
        setTimeStart(dayjs(value).startOf('month').unix())
        setTimeEnd(dayjs(value).endOf('month').unix())
        setCurrentYear(value)
    }

    const renderContent = () => {
        switch(value) {
            case 'team': {
                return <Team
                            provider={provider}
                            timeStart={timeStart}
                            timeEnd={timeEnd}
                            sx={{width: "100%"}}
                        />
            }
            case 'appeals': 
                return <Appeals
                            timeStart={timeStart}
                            timeEnd={timeEnd}
                            sx={{width: "100%"}}
                        />
            case 'billings': 
                return (
                    billings.length > 0 
                        ?
                            <AnaliticsBillings
                                billings={billings}
                                timeStart={timeStart}
                                timeEnd={timeEnd}
                                sx={{width: "100%"}}
                            />
                        :
                             <Box sx={{display: 'flex', justifyContent: 'center', p: 3 }}>
                                <Typography variant="h5">No data</Typography>
                            </Box>
                );
            case 'networks': 
                return <Networks
                            timeStart={timeStart}
                            timeEnd={timeEnd}
                            sx={{width: "100%"}}
                        />
            default: {
                return (
                    <Typography>default</Typography>
                );
            }
        }
    }

    return (
        <Stack spacing={2} width={"100%"}>
            <Paper sx={{p: 1, minWidth: "320px"}}>
                <Stack
                    direction="row"
                    spacing={{ xs: 1, sm: 2 }}
                    useFlexGap
                    sx={{ flexWrap: 'wrap' }}
                >
                    <Typography variant="h2">{provider.name}</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Period"
                                maxDate={dayjs().startOf('month')}
                                openTo="month"
                                views={['year', 'month']}
                                yearsOrder="desc"
                                sx={{ minWidth: 250 }}
                                value={currentYear}
                                onChange={(newValue) => changeCurrentYear(newValue)}
                            />
                    </LocalizationProvider>
                </Stack>
            </Paper>
            <Paper>
                <Box width={"100%"} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab value={"team"} label={"Team"} wrapped/>
                        <Tab value={"appeals"} label={"Appeals"} wrapped/>
                        <Tab value={"billings"} label={"Billings"} wrapped/>
                        <Tab value={"networks"} label={"Networks"} wrapped/>
                    </Tabs>
                </Box>
            </Paper>
            {loading 
                ? renderContent()
                :   <Box sx={{display: 'flex', justifyContent: 'center', p: 3 }}>
                        <CircularProgress color="primary" />
                    </Box>
            }
        </Stack>
    )};

export default Provider;